import { render, staticRenderFns } from "./IconYelp.vue?vue&type=template&id=3c2a2160&"
import script from "./IconYelp.vue?vue&type=script&lang=js&"
export * from "./IconYelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports